const state = {
  refreshComponente: Number
}

const mutations = {
  setRefreshComponente (state, value) {
    state.refreshComponente = value
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/refreshComponente.js